import { createSlice } from "@reduxjs/toolkit";

import { COMPANY_BRANCH } from "../../common/utils/constants";

const storedSelectedBranch = localStorage.getItem("hub-app-booking-selected-branch");
const init = {
  selectedBranch: storedSelectedBranch || COMPANY_BRANCH.BRITANNIA,
  selectedBranchSavedConfig: null,
  selectedBranchUpdatedConfig: null,
  loadingBlockedTimes: true,
};

const bookingSlice = createSlice({
  name: "booking",
  initialState: init,
  reducers: {
    setSelectedBranch(state, action) {
      window.localStorage.setItem("hub-app-booking-selected-branch", action.payload);
      state.selectedBranch = action.payload;
      state.blockedTimesUpdated = Date.now();
    },

    setSelectedBranchInitialConfig(state, action) {
      state.selectedBranchSavedConfig = action.payload;
      state.selectedBranchUpdatedConfig = action.payload;
    },

    setSelectedBranchSavedConfig(state, action) {
      state.selectedBranchSavedConfig = action.payload;
    },

    setSelectedBranchUpdatedConfig(state, action) {
      state.selectedBranchUpdatedConfig = action.payload;
    },

    setLoadingBlockedTimes(state, action) {
      state.loadingBlockedTimes = action.payload;
    },
  },
});

export const bookingActions = bookingSlice.actions;

export default bookingSlice.reducer;
